import Vue from 'vue'
// import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueAxios from 'vue-axios'
import axios from 'axios'
import Vuelidate from 'vuelidate' 
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

export const EventBus = new Vue()

Vue.filter('toPrice', (value, precision, append = '') => {
  return `${parseFloat(value).toFixed(precision)} ${append}`
})

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) },
}).$mount('#app')
